import React, {useEffect} from 'react';
import './DealerConfirmation.css';
import {useNavigate} from 'react-router-dom';
import PropTypes from 'prop-types';
import {updateToggleDealerConfirmationDialog} from '../../redux/app-state-slice';
import {initialState} from '../../redux/initialState';
import {tagDealerSubmissionConfirmationPage} from '../../Services/TaggingService/TaggingService';
import DealerInquirySummary from '../DealerInquirySummary/DealerInquirySummary';

export const returnToOfferPage = (desktop, dispatch, navigate) => {
  if (desktop) {
    dispatch(updateToggleDealerConfirmationDialog(false));
  } else {
    navigate(-3);
  }
};

function DealerConfirmation({customerData, dispatch, appConfig}) {
  const navigate = useNavigate();
  const selectedDealer = customerData?.selectedDealer?.value?.vendorName;
  const isMobile = window.innerWidth < 600;
  const isDesktop = window.innerWidth >= 1024;

  useEffect(() => {
    tagDealerSubmissionConfirmationPage(customerData.specialEvent.value, customerData.countryCode.value, customerData.languageCode.value);
  });

  return (
    <div data-testid='dealer-confirmation-container'>
      {customerData.dealerLeadStatusMessage.value === 'Success' ? (
        <div className='prequal--web--dealer-confirmation-container'>
          <p className='prequal--web--confirmation-status-text-fomo' data-testid='confirmation-status-text'>
            Your Inquiry Has Been
            {isMobile ? <br /> : ' '}
            Submitted
          </p>
          <p className='prequal--web--confirmation-body-text-fomo'>
            A salesperson at <span data-testid='dealer-name'>{selectedDealer}</span> will contact you within the next business day to
            schedule an appointment.
          </p>
          <div className='prequal--web--inquiry-summary-fomo'>
            <div className='prequal--web--inquiry-summary-container'>
              <DealerInquirySummary dispatch={dispatch} customerData={customerData} appConfig={appConfig} />
            </div>
            <div className='prequal--web-dealer-display-image-parent'>
              <div className='prequal--web--dealer-display-image-fomo' />
            </div>
          </div>
        </div>
      ) : (
        <div className='prequal--web--dealer-confirmation-container'>
          <p className='prequal--web--confirmation-status-text' data-testid='confirmation-status-text'>
            We&lsquo;re Sorry,
            {isMobile ? <br /> : ' '}
            Something Went Wrong.
          </p>
          <p className='prequal--web--confirmation-body-text'>
            We were unable to connect with the dealer. Please reach out to <span data-testid='dealer-name'>{selectedDealer}</span> directly
            to schedule an appointment
          </p>
          <div className='prequal--web--return-button prequal--web--align-center'>
            <button
              type='button'
              disabled={false}
              className='prequal--web--submit-prequalification-button'
              onClick={() => returnToOfferPage(isDesktop, dispatch, navigate)}
            >
              Return to Prequalification Offer
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

DealerConfirmation.propTypes = {
  customerData: PropTypes.object,
  dispatch: PropTypes.func
};

DealerConfirmation.defaultProps = {
  customerData: initialState,
  dispatch: null
};

export default DealerConfirmation;
